export function Changelog() {
    return (
        <div className="p-8 bg-gray-100 rounded-lg shadow-md m-2 max-w-screen">
            <h1 className="text-3xl font-bold text-gray-500">
                CUREOsity Web Access Cloud Version 1.5:
            </h1>
            <p className="text-xl text-gray-700 mb-2">Aktuelle Verbesserungen:</p>
            <ul className="list-disc list-inside space-y-2">
                <li className="text-lg text-gray-600">
                    Bestätigungsdialog beim Löschen von Referenzen und Adressen mit klarer Erklärung, was entfernt wird
                </li>
                <li className="text-lg text-gray-600">
                    Beim Löschen einer Referenz werden jetzt auch alle zugehörigen Karten-Markierungen aus der Datenbank entfernt
                </li>
                <li className="text-lg text-gray-600">
                    Verbesserte Geocodierung der Adressen für die Google Map
                </li>
                <li className="text-lg text-gray-600">
                    Automatisches Deployment über GitHub Actions auf Google Cloud Run
                </li>
                <li className="text-lg text-gray-600">
                    Sicherheit: API-Schlüssel und Tokens werden nicht mehr im Quellcode gespeichert
                </li>
                <li className="text-lg text-gray-600">
                    Bug fixes
                </li>
            </ul>
        </div>
    );
}
